/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close-light': {
    width: 20,
    height: 21,
    viewBox: '0 0 20 21',
    data: '<rect pid="0" y=".01" width="20" height="20" rx="10" _fill="#E2EAEC"/><path pid="1" d="M13.889 6.121a.5.5 0 0 0-.707 0L10 9.303 6.818 6.121l-.07-.058a.5.5 0 0 0-.637.765l3.182 3.182-3.182 3.182-.058.07a.5.5 0 0 0 .765.637L10 10.717l3.182 3.182.07.058a.5.5 0 0 0 .637-.765l-3.182-3.182 3.182-3.182.058-.07a.5.5 0 0 0-.058-.637z" _fill="#234357"/>'
  }
})
